var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('h1',[_vm._v("NasaAPI")]),_c('v-spacer')],1)],1),_c('maincomp',{staticStyle:{"margin-top":"30px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }